import { FaMosque } from "react-icons/fa";
import './MosqueLoader.scss';
const MosqueLoader = () => {
  return (
    <div className="mosque-loader-overlay">
      <div className="mosque-loader">
        <div className="mosque-circle">
          <FaMosque className="mosque-icon" />
          <div className="rotating-ring"></div>
        </div>
      </div>
    </div>
  );
};

export default MosqueLoader;
